/**
 * The Vero Software site theme. Call getTheme(mode) with "light" or "dark"
 * to build an MUI theme for that color scheme.
 */

// @mui material components
import { createTheme } from "@mui/material/styles";

// Vero base styles
import getColors from "assets/theme/base/colors";
import breakpoints from "assets/theme/base/breakpoints";
import typography from "assets/theme/base/typography";
import boxShadows from "assets/theme/base/boxShadows";
import borders from "assets/theme/base/borders";
import getGlobals from "assets/theme/base/globals";

// Vero helper functions
import boxShadow from "assets/theme/functions/boxShadow";
import hexToRgb from "assets/theme/functions/hexToRgb";
import linearGradient from "assets/theme/functions/linearGradient";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

// Component style overrides that vary by color mode
import getCard from "assets/theme/components/card";
import getDivider from "assets/theme/components/divider";
import getButton from "assets/theme/components/button";
import getInput from "assets/theme/components/form/input";
import getInputLabel from "assets/theme/components/form/inputLabel";
import getTextField from "assets/theme/components/form/textField";

// Component style overrides that are mode-independent
import container from "assets/theme/components/container";
import buttonBase from "assets/theme/components/buttonBase";
import icon from "assets/theme/components/icon";
import svgIcon from "assets/theme/components/svgIcon";
import link from "assets/theme/components/link";
import avatar from "assets/theme/components/avatar";

export default function getTheme(mode) {
  const colors = getColors(mode);

  return createTheme({
    palette: { mode, ...colors },
    breakpoints: { ...breakpoints },
    typography: { ...typography },
    boxShadows: { ...boxShadows },
    borders: { ...borders },
    functions: {
      boxShadow,
      hexToRgb,
      linearGradient,
      pxToRem,
      rgba,
    },

    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ...getGlobals(colors),
          ...container,
        },
      },
      MuiCard: getCard(colors),
      MuiDivider: getDivider(colors),
      MuiButton: getButton(colors),
      MuiInput: getInput(colors),
      MuiInputLabel: getInputLabel(colors),
      MuiTextField: getTextField(colors),
      MuiButtonBase: { ...buttonBase },
      MuiIcon: { ...icon },
      MuiSvgIcon: { ...svgIcon },
      MuiLink: { ...link },
      MuiAvatar: { ...avatar },
    },
  });
}
